import { forwardRef, useCallback, useImperativeHandle, useRef, useState } from 'react';
import { SigninPopupUI } from '../firebaseHelper';

// Keep one FirebaseUI instance mounted while a caller changes its surrounding step.
const PhoneSigninPanel = forwardRef(function PhoneSigninPanel({ onStageChange, onBusyChange, autoFocusPhone = true, hasBackAction = false, className = '' }, ref) {
    const panelRef = useRef(null);
    const [phoneStage, setPhoneStage] = useState('phone');
    const onStageChangeRef = useRef(onStageChange);
    onStageChangeRef.current = onStageChange;
    const handleStageChange = useCallback(stage => {
        setPhoneStage(stage);
        onStageChangeRef.current?.(stage);
    }, []);
    useImperativeHandle(ref, () => ({
        changeNumber: () => panelRef.current?.querySelector('.firebaseui-id-change-phone-number-link')?.click(),
    }), []);

    return (
        <div
            ref={panelRef}
            className={`phoneSigninPanel${className ? ` ${className}` : ''}`}
            data-has-back-action={hasBackAction ? 'true' : undefined}
        >
            <SigninPopupUI
                compactPhone
                autoFocusPhone={autoFocusPhone}
                onPhoneStageChange={handleStageChange}
                onPhoneBusyChange={onBusyChange}
                externalPhoneTitles={Boolean(onStageChange)}
            />
            {phoneStage === 'phone' && <div className='phoneSigninPanelLegal'>
                <a href='/terms.html'>Terms</a><span aria-hidden='true'> · </span><a href='/privacy.html'>Privacy</a>
            </div>}
            <p className='phoneSigninPanelCaptchaDisclosure'>This site is protected by reCAPTCHA.</p>
        </div>
    );
});

export default PhoneSigninPanel;
